import { render } from "./lightbox-two.vue?vue&type=template&id=bbc6b8c0"
import script from "./lightbox-two.vue?vue&type=script&lang=js"
export * from "./lightbox-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__